import React, { useState, useEffect } from "react";
import { Calendar, Loader2 } from "lucide-react";
import { academicService, AcademicYearItem } from "../../services/academicService";

export const AcademicSessionPage: React.FC = () => {
  const [sessions, setSessions] = useState<AcademicYearItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSessions();
  }, []);

  const fetchSessions = async () => {
    try {
      const data = await academicService.getAcademicYears();
      setSessions(data.results || data || []);
    } catch {
      setSessions([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-5 bg-slate-900/90 border border-slate-800 rounded-xl shadow-md text-xs font-sans space-y-4">
      <div className="flex items-center justify-between pb-3 border-b border-slate-800">
        <div className="flex items-center gap-2">
          <Calendar className="w-5 h-5 text-indigo-400" />
          <h2 className="text-base font-bold text-slate-100">Academic Sessions & Term Open/Close</h2>
        </div>
      </div>

      {loading ? (
        <div className="p-8 text-center text-slate-400 text-xs flex items-center justify-center gap-2">
          <Loader2 className="w-4 h-4 animate-spin text-indigo-400" /> Loading Academic Sessions...
        </div>
      ) : (
        <div className="space-y-3">
          {sessions.map((s) => (
            <div
              key={s.id}
              className="flex items-center justify-between p-4 bg-slate-950 border border-slate-800 rounded-xl font-mono"
            >
              <div>
                <div className="flex items-center gap-2 mb-1">
                  <span
                    className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase ${
                      s.is_current
                        ? "bg-emerald-950 text-emerald-300 border border-emerald-800"
                        : "bg-slate-800 text-slate-400"
                    }`}
                  >
                    {s.is_current ? "ACTIVE" : "INACTIVE"}
                  </span>
                  <h3 className="font-bold text-slate-100 text-sm font-sans">{s.name}</h3>
                </div>
                <p className="text-[11px] text-slate-400">
                  Duration: {s.start_date || "N/A"} to {s.end_date || "N/A"}
                </p>
              </div>
            </div>
          ))}
          {sessions.length === 0 && (
            <div className="p-8 text-center text-slate-500 font-sans border border-slate-800 rounded-xl bg-slate-950">
              No academic sessions configured for this institution yet.
            </div>
          )}
        </div>
      )}
    </div>
  );
};
